<template>
    <label class="form-label">
        <slot></slot>
        <span class="bg-main-color px-4 py-0.5 text-white rounded-full text-sm ml-2 break-keep"
              v-if="!required">任意</span>
    </label>
</template>

<script>
export default {
    name: "FormLabel",
    props: {
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
label {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: fit-content;
}
</style>
